import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

interface DataBagTableProps {

}

@Dce("DataBagTable")
export default class DataBagTable extends DceComponent<DataBagTableProps> {

    constructor(elem: DceHTMLElement, props: DataBagTableProps) {
        super(elem, props);

        console.log("ZZZZZZZZ");

        $(this.elem).find('.details-header-name').on('click', function(){

            var $this = $(this);

            if($this.hasClass('opened')){
                $this.removeClass('opened');
                $this.closest('.row').next('.row').find('.col-details').slideUp();
            }else{
                $this.addClass('opened');
                $this.closest('.row').next('.row').find('.col-details').slideDown();
            }

        });

    }

    public action(o: any){

    }

}
